<template>
    <xx-select
        v-model="model"
        :list="list"
        v-bind="attrs"
        class="tree-select"
        v-on="$listeners"
        @change="change"
    />
</template>

<script>
/**
 * 门店选择器 （vss）
 */
export default {
    name: 'PoiSelectForSupplier',
    props: {
        value: {
            type: [String, Number],
            required: true,
            default: '',
        },
        poiType: {
            type: [String, Number],
            default: () => '',
        },
        /**
         * 是否查询全量的门店
         * true: 查询全量的门店
         * false: 查询当前供应商绑定的门店
         */
        flag: {
            type: Boolean,
            default: false,
        },
        supplierIdList: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            model: this.value,
            list: [],
        };
    },
    computed: {
        attrs() {
            return {
                placeholder: '请选择',
                ...this.$attrs,
            };
        },
    },
    watch: {
        value: {
            deep: true,
            handler(v) {
                this.model = v;
            },
        },
        supplierIdList: {
            deep: true,
            handler() {
                this.fetchData();
                this.$emit('input', '');
            },
        },
    },
    methods: {
        async fetchData() {
            // 开启缓存
            const { flag, poiType, supplierIdList } = this;
            const res = await this.$hGet('/api/m/vss/poi/list', { flag, poiType, supplierIdList }, { cache: true });
            const list = (res || []).map((v) => ({
                ...v,
                value: v.poiId,
                label: v.name,
            }));
            this.list = list;
            this.$emit('loaded', list);
        },
        change(v) {
            this.$emit('input', v);
        },
    },
};
</script>
